import config from './config'
import { routerReducer } from 'react-router-redux'
import fieldsReducer from '../common/modules/fields/fields-reducer'
import errorsReducer from '../common/modules/errors/errors-reducer'
import productDataReducer from '../common/modules/product-data/product-data-reducer'
import statusReducer from '../common/modules/status/status-reducer'
import formReducer from '../common/modules/form/form-reducer'
import cobrandReducer from '../common/modules/cobrand/cobrand-reducer'
import navigationReducer from '../common/modules/navigation/navigation-reducer'
import configReducer from '../common/modules/config/config-reducer'
import progressReducer from '../common/modules/progress/progress-reducer'
import validationReducer from '../common/modules/validation/validation-reducer'
import submissionReducer from '../common/modules/submission/submission-reducer'
import suburbAutoCompleteReducer from '../common/modules/suburb-auto-complete/suburb-auto-complete-reducer'
import addressValidationReducer from '../common/modules/address-validation/address-validation-reducer'


export default {
    cobrand: cobrandReducer(),
    config: configReducer(config),
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/reducer-map.ts